'use client';
import { jsx } from 'react/jsx-runtime';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(t);
        for(o = 0; o < p.length; o++)r = p[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, n = {}, p = Object.keys(t);
    for(o = 0; o < p.length; o++)r = p[o], e.indexOf(r) >= 0 || (n[r] = t[r]);
    return n;
}
const EmptyState = renderWithRef('EmptyState', null, (r, p)=>{
    useComponentStylesLoaded('EmptyState', SWAN_STYLE_KEY_MAP.emptyState);
    let { children: s, size: a = 'standard' } = r, i = _object_without_properties(r, [
        "children",
        "size"
    ]);
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: p,
        classNames: new Set([
            'swan-empty-state',
            `swan-empty-state-${a}`
        ]),
        props: i,
        children: s
    });
});

export { EmptyState };
